<template>
  <div class="flex flex-wrap -mx-4">
    <div class="w-full sm:w-1/3 px-4">
      <div class="sticky pin-t-4">
        <example-header
          title="Images"
          :showing-code="showingCode"
          @toggle="toggleCode"
        />
        <div class="my-2">
          <p class="mb-2">
            Vue Packer must know each item height as it is mounted. The height
            of an image will not be available to the browser before it has
            loaded, by which time the grid has already been laid out.
          </p>
          <p>
            When grid items contain images, the height of the image must be
            specified. You can maintain responsiveness by absolutely positioning
            the image and adding padding to the container element.
            <a
              href="https://www.andyshora.com/css-image-container-padding-hack.html"
              target="_blank"
              >Read more here</a
            >.
          </p>
        </div>
        <div class="my-4">
          <button
            class="mr-1 text-sm border border-grey-dark text-grey-dark hover:bg-grey-dark hover:text-white font-bold py-1 px-2 "
            @click="addItem"
          >
            Add
          </button>
          <button
            class="text-sm border border-grey-dark text-grey-dark hover:bg-grey-dark hover:text-white font-bold py-1 px-2 "
            @click="removeLastItem"
          >
            Remove
          </button>
        </div>
      </div>
    </div>
    <div class="w-full sm:w-2/3 px-4">
      <div v-if="showingCode">
        <pre class="p-4 text-sm bg-grey-lighter">
<code v-pre><span class="hl-tag">&lt;template&gt;</span>
  <span class="hl-tag">&lt;vue-packer :reactor=<span class="hl-string">&quot;items&quot;</span>&gt;</span>
    <span class="hl-comment">&lt;!-- Your components --&gt;</span>
    <span class="hl-tag">&lt;item-component 
      v-for=<span class="hl-string">&quot;item of items&quot;</span>
      :key=<span class="hl-string">&quot;item.id&quot;</span>
    /&gt;</span>
  <span class="hl-tag">&lt;/vue-packer&gt;</span>
<span class="hl-tag">&lt;/template&gt;</span>

<span class="hl-tag">&lt;style&gt;</span>
.packer-sizer {
  <span class="hl-keyword">width</span>: <span class="hl-number">33.333%</span>;
}
<span class="hl-tag">&lt;/style&gt;</span></code></pre>
      </div>
      <vue-packer v-else :reactor="items" base-class="ex-images">
        <div
          v-for="{ id, paddingTop, url } of items"
          :key="id"
          class="ex-images-item"
          :style="{ paddingTop }"
        >
          <div class="ex-images-item-inner">
            <img :src="url" alt="" />
          </div>
        </div>
      </vue-packer>
    </div>
  </div>
</template>

<script>
import example from '@/mixins/example';

export default {
  mixins: [example],
  methods: {
    createItem() {
      this.count = this.count + 1;
      const width = this.getRand(40, 70) * 10; // Between 400 and 700
      const height = this.getRand(20, 70) * 10; // Between 200 and 500
      const url = `https://source.unsplash.com/${width}x${height}`;
      return {
        id: this.count,
        paddingTop: `${(height / width) * 100}%`,
        url,
      };
    },
  },
};
</script>

<style lang="sass">
.ex-images
  margin: -0.5rem -0.25rem

.ex-images-sizer
  width: percentage(1/3)

.ex-images-item
  position: relative
  display: flex
  align-items: center
  justify-content: center
  margin: 0.5rem 0.25rem
  background: #ccc

.ex-images-item-inner
  position: absolute
  width: 100%
  height: 100%
  top: 0
  left: 0
  img
    object-fit: cover
    display: block
    width: 100%
    height: 100%
</style>
